export default __webpack_public_path__ + "static/media/menu-big.7fe8b6a8.svg";